import styled from 'styled-components';

export const TextQuestionStyles = styled.p`
  font-size: 15px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
  margin: 0;
`;
